var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      staticClass: "button",
      class: _vm.buttonClass,
      attrs: { type: "submit", disabled: _vm.isDisabled },
      on: {
        click: function ($event) {
          return _vm.$emit("click")
        },
      },
    },
    [
      _vm.icon
        ? _c("icon", { attrs: { name: _vm.icon, size: _vm.iconSize } })
        : _vm._e(),
      _c("span", [_vm._v(_vm._s(_vm.label))]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }